import { render, staticRenderFns } from "./modal-detail-contract.vue?vue&type=template&id=1189b2fa&scoped=true"
import script from "./modal-detail-contract.vue?vue&type=script&lang=js"
export * from "./modal-detail-contract.vue?vue&type=script&lang=js"
import style0 from "./modal-detail-contract.vue?vue&type=style&index=0&id=1189b2fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1189b2fa",
  null
  
)

export default component.exports